// removed by extract-text-webpack-plugin
module.exports = {"tags":"tags__3OadwVXTOWNx","suiList":"suiList__3x7R_GhEMsyG"};